/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  getDoc,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";
import { db } from "../../../firebase";

import usePagination from "../../helper/paginate/Pagination";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Swal from "sweetalert2";
import "../../../pages/dashboard/yoda.css";
import "./DataTableDemo.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Switch, Col, Row, Modal, Checkbox } from "antd";
import axios from "axios";
import {
  Tag,
  Eye,
  Edit,
  Trash,
  MoreVertical,
  ChevronDown,
  ChevronUp,
  Sparkle,
  ExternalLink,
  BarChart3,
  Package,
  LayoutTemplate,
} from "lucide-react";
import useIsDark from "../../../utils/isDark";
import { updateProduct } from "../../../redux/products/products";
import { fetchStore } from "../../../redux/store/store";
const DataTableTemplatingDemo = ({
  setLgShow,
  setData,
  filter,
  pageSize,
  filteredProducts,
  allProducts,
  filter2,
}) => {
  // Get products from Redux or filteredProducts prop
  const products = useSelector((state) => {
    const allProducts = state.ProductsReducer || [];

    // Filter out deleted products
    let activeProducts = allProducts.filter((product) => product.deleted !== 1);

    // 🔴 طبق فلتر الحالة (out_of_stock, low_stock, hidden, ai_generated)
    if (filter2) {
      switch (filter2) {
        case "out_of_stock":
          activeProducts = activeProducts.filter((p) => p.qty <= 0);
          break;
        case "low_stock":
          activeProducts = activeProducts.filter(
            (p) => p.qty > 0 && p.qty <= p.limitedValue,
          );
          break;
        case "hidden":
          activeProducts = activeProducts.filter((p) => p.show === "0");
          break;
        case "ai_generated":
          activeProducts = activeProducts.filter(
            (p) => p.created_via === "FoorAiLandingPageGenerator",
          );
          break;
        default:
          break;
      }
    }

    if (filter) {
      const searchTerm = filter.toLowerCase();
      return activeProducts.filter(
        (product) =>
          (product.name && product.name.toLowerCase().includes(searchTerm)) ||
          (product.sku && product.sku.toLowerCase().includes(searchTerm)),
      );
    }
    // Return all active products if no filter is applied
    return activeProducts;
  });

  const allProductsList = useSelector((state) => {
    const allProds = state.ProductsReducer || [];
    // Filter out deleted products
    return allProds.filter((product) => product.deleted !== 1);
  });
  const dispatch = useDispatch();

  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const [confirmers, setConfirmers] = useState([]);
  const [page, setPage] = useState(1);
  const PER_PAGE = pageSize;
  const [expandedRows, setExpandedRows] = useState({});
  const count = Math.ceil(products.length / PER_PAGE);
  const _DATA = usePagination(products, PER_PAGE);
  const [isAll, setIsAll] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [pendingRowData, setPendingRowData] = useState(null);
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const direction = currentLang === "ar" ? "rtl" : "ltr";
  const isDark = useIsDark();
  const currencyMap = {
    دج: {
      ar: "دج",
      fr: "DA",
      en: "DZD",
    },
  };
  const localizedCurrency =
    currencyMap[store.currencySymbol]?.[i18n.language] || store.currencySymbol;

  // Add state to track which dropdown is open
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [isSendingAllToEcomanager, setIsSendingAllToEcomanager] =
    useState(false);
  const [sendingProductIds, setSendingProductIds] = useState(new Set());
  const darkModeStyles = `
  /* Mode sombre spécifique au tableau personnalisé */
  .dark table thead tr th {
    background-color: #1e1e1e !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
    border-top: 1px solid #3c3a3d !important;
    border-bottom: 1px solid #3c3a3d !important;
  }

  .dark table tbody tr {
    background-color: #181919 !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
  }

  .dark table tbody tr:nth-child(even) {
    background-color: #1e1e1e !important;
  }

  .dark table tbody tr:nth-child(odd) {
    background-color: #181919 !important;
  }

  .dark table tbody tr td {
    border-color: #3c3a3d !important;
    color: #d1d5db !important;
  }
`;

  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.innerHTML = darkModeStyles;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  const orderKey =
    account?.productMode === "digital"
      ? "digitalProductsOrder"
      : "productsOrder";

  const buildOrderList = (existingOrder, sourceList) => {
    const ids = (sourceList || []).map((p) => p.id).filter(Boolean);
    const normalizedOrder = Array.isArray(existingOrder)
      ? existingOrder.filter((id) => ids.includes(id))
      : [];

    ids.forEach((id) => {
      if (!normalizedOrder.includes(id)) {
        normalizedOrder.push(id);
      }
    });

    return normalizedOrder;
  };

  const moveProductOrder = async (productId, direction) => {
    if (!store?.id || !productId) return;

    const sourceList = allProductsList?.length ? allProductsList : products;
    const baseOrder = buildOrderList(store?.[orderKey], sourceList);
    const currentIndex = baseOrder.indexOf(productId);
    if (currentIndex < 0) return;

    const swapIndex = direction === "up" ? currentIndex - 1 : currentIndex + 1;
    if (swapIndex < 0 || swapIndex >= baseOrder.length) return;

    const nextOrder = [...baseOrder];
    [nextOrder[currentIndex], nextOrder[swapIndex]] = [
      nextOrder[swapIndex],
      nextOrder[currentIndex],
    ];

    try {
      await updateDoc(doc(db, "store", store.id), {
        [orderKey]: nextOrder,
      });
      dispatch(fetchStore({ ...store, [orderKey]: nextOrder }));
    } catch (error) {
      console.error("Error updating product order:", error);
    }
  };

  useEffect(() => {
    if (!store?.id) return;
    const sourceList = allProductsList?.length ? allProductsList : products;
    if (!sourceList?.length) return;

    const nextOrder = buildOrderList(store?.[orderKey], sourceList);
    if (!nextOrder.length) return;

    const currentOrder = Array.isArray(store?.[orderKey])
      ? store[orderKey]
      : [];
    const isSameOrder =
      currentOrder.length === nextOrder.length &&
      currentOrder.every((id, index) => id === nextOrder[index]);

    if (isSameOrder) return;

    updateDoc(doc(db, "store", store.id), {
      [orderKey]: nextOrder,
    })
      .then(() => {
        dispatch(fetchStore({ ...store, [orderKey]: nextOrder }));
      })
      .catch((error) => {
        console.error("Error initializing product order:", error);
      });
  }, [store?.id, store?.[orderKey], orderKey, allProductsList, products]);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  // Toggle row expansion
  const toggleRow = (productId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [productId]: !prev[productId],
    }));
  };

  useEffect(() => {
    const fetchConfirmersAndInvitations = async () => {
      if (!(account && account.user)) {
        setConfirmers([]);
        return;
      }

      try {
        const confirmersQuery = query(
          collection(db, "confirmers"),
          where("addedBy", "==", account.user),
        );

        const invitationsQuery = query(
          collection(db, "invitations"),
          where("status", "==", 2),
          where("shopUser", "==", account.user),
        );

        const [confirmersSnapshot, invitationsSnapshot] = await Promise.all([
          getDocs(confirmersQuery),
          getDocs(invitationsQuery),
        ]);

        const confirmersList = confirmersSnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));

        const confirmUserIds = [
          ...new Set(
            invitationsSnapshot.docs
              .map((doc) => doc.data()?.confirmUser)
              .filter(Boolean),
          ),
        ];

        let invitationConfirmers = [];
        if (confirmUserIds.length > 0) {
          const batches = [];
          for (let i = 0; i < confirmUserIds.length; i += 10) {
            batches.push(confirmUserIds.slice(i, i + 10));
          }

          const inviterSnapshots = await Promise.all(
            batches.map((batch) =>
              getDocs(
                query(collection(db, "confirmers"), where("user", "in", batch)),
              ),
            ),
          );

          invitationConfirmers = inviterSnapshots.flatMap((snapshot) =>
            snapshot.docs.map((item) => ({
              ...item.data(),
              id: item.id,
            })),
          );
        }

        const mergedConfirmers = new Map();
        [...confirmersList, ...invitationConfirmers].forEach((item) => {
          mergedConfirmers.set(item.id || item.user, item);
        });

        setConfirmers(Array.from(mergedConfirmers.values()));
      } catch (error) {
        console.error("Error fetching confirmers/invitations:", error);
      }
    };

    fetchConfirmersAndInvitations();
  }, [account?.user]);

  const changepaid = async (data, status) => {
    const nextProduct = { ...data, show: status };
    await setDoc(doc(db, "products", data.id), nextProduct);
    dispatch(updateProduct(nextProduct));
  };

  const message = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success mx-2",
        cancelButton: "btn btn-danger mx-2",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title:
          t("services.contact_for_free_trial"),
        showCancelButton: true,
        confirmButtonText: t("ship.yes"),
        cancelButtonText: t("ship.no"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.open("https://m.me/F0orweb", "_blank", "noopener,noreferrer");
        } else result.dismiss === Swal.DismissReason.cancel;
      });
  };

  const truncateName = (name, maxLength = 20) => {
    return name.length > maxLength
      ? name.substring(0, maxLength) + "..."
      : name;
  };

  const handleDelete = async (data) => {
    Swal.fire({
      title: t("ship.confirm_delete"),
      text: t("ship.delete_order_prompt"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
      confirmButtonText: t("ship.yes"),
      cancelButtonText: t("ship.no"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // تحديث deleted: 1 يعني أنه تم الحذف
          const nextProduct = { ...data, deleted: 1 };
          await setDoc(doc(db, "products", data.id), nextProduct);
          dispatch(updateProduct(nextProduct));

          Swal.fire({
            icon: "success",
            title: t("Products.Table.delete.successTitle"),
            text: t("orders.product_deleted_success"),
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
            position: "bottom-end",
            toast: true,
          });
        } catch (error) {
          console.error("Error deleting product:", error);
          Swal.fire({
            icon: "error",
            title: t("error"),
            text: t("Products.Table.delete.errorText"),
            confirmButtonColor: "#7e5395",
          });
        }
      }
    });
  };

  const handleUpdate = async (rowData) => {
    setData(rowData);
    setLgShow(true);
  };

  const isEcomanagerRequestSuccessful = (response) => {
    if (!response || response.status < 200 || response.status >= 300) {
      return false;
    }

    const payload = response.data;

    if (!payload || typeof payload !== "object") {
      return true;
    }

    if (typeof payload.success === "boolean") return payload.success;
    if (typeof payload.ok === "boolean") return payload.ok;
    if (typeof payload.status === "boolean") return payload.status;

    if (typeof payload.status === "string") {
      const normalized = payload.status.toLowerCase();
      if (["success", "ok", "created", "done"].includes(normalized)) {
        return true;
      }
      if (["error", "failed", "fail"].includes(normalized)) {
        return false;
      }
    }

    if (payload.error || payload.errors) {
      return false;
    }

    return true;
  };

  const getEcomanagerFailureMessage = (payload) => {
    if (!payload || typeof payload !== "object") return null;

    if (typeof payload.message === "string" && payload.message.trim()) {
      return payload.message;
    }

    if (typeof payload.error === "string" && payload.error.trim()) {
      return payload.error;
    }

    if (Array.isArray(payload.errors) && payload.errors.length > 0) {
      const firstError = payload.errors[0];
      if (typeof firstError === "string") return firstError;
      if (firstError && typeof firstError.message === "string") {
        return firstError.message;
      }
    }

    return null;
  };

  const getEcomanagerErrorMessage = (error) => {
    const payload = error?.response?.data;

    if (!payload) {
      return error?.message || null;
    }

    const directMessage = getEcomanagerFailureMessage(payload);
    if (directMessage) {
      return directMessage;
    }

    if (payload?.errors && typeof payload.errors === "object") {
      const errorValues = Object.values(payload.errors).flat();
      const firstValue = errorValues.find(Boolean);
      if (typeof firstValue === "string") return firstValue;
      if (firstValue && typeof firstValue.message === "string") {
        return firstValue.message;
      }
    }

    return error?.message || null;
  };

  const handleEcomanager = async (products) => {
    const urlEcomanager = `${store.Secomanager}products`;
    try {
      const response = await axios.post(
        urlEcomanager,
        {
          title: products?.name,
          sku: products?.sku,
          price: parseInt(products?.price),
          is_active: true,
          open_stock: true,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${store.ecomanager}`,
          },
        },
      );

      if (!isEcomanagerRequestSuccessful(response)) {
        throw new Error(
          getEcomanagerFailureMessage(response?.data) ||
            "Ecomanager request was not accepted",
        );
      }

      if (products?.id) {
        await updateDoc(doc(db, "products", products.id), {
          ecommanageractive: true,
        });
        dispatch(updateProduct({ ...products, ecommanageractive: true }));
      }

      return response.data;
    } catch (error) {
      console.error("حدث خطأ:", error);
      throw error;
    }
  };

  const handleSendAllToEcomanager = async () => {
    const sourceList = allProductsList?.length ? allProductsList : products;
    const productsToSend = (sourceList || []).filter(
      (product) => !product?.ecommanageractive,
    );

    if (!productsToSend.length) {
      Swal.fire({
        icon: "info",
        title: t("Products.Table.ecomanager.noProducts"),
        text: t("Products.Table.ecomanager.noProductsText"),
        confirmButtonColor: "#7e5395",
      });
      return;
    }

    const confirmResult = await Swal.fire({
      title: t("Products.Table.ecomanager.confirmTitle"),
      text: t("Products.Table.ecomanager.confirmText", {
        count: productsToSend.length,
      }),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("Products.Table.ecomanager.confirmButton"),
      cancelButtonText: t("Products.Table.ecomanager.cancelButton"),
      confirmButtonColor: "#7e5395",
      cancelButtonColor: "#e87778",
    });

    if (!confirmResult.isConfirmed) return;

    setIsSendingAllToEcomanager(true);

    let successCount = 0;
    let failCount = 0;
    const failMessages = [];
    const total = productsToSend.length;

    // Afficher la progression
    Swal.fire({
      title: t("Products.Table.ecomanager.progressTitle", {
        current: 0,
        total,
      }),
      html: `<div style="width:100%;background:#eee;border-radius:8px;overflow:hidden;height:18px;margin-top:10px;"><div id="eco-progress-bar" style="width:0%;height:100%;background:#7e5395;transition:width 0.3s;border-radius:8px;"></div></div><p id="eco-progress-text" style="margin-top:8px;font-size:13px;color:#888;">${t("Products.Table.ecomanager.progressText")}</p>`,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      for (let i = 0; i < total; i++) {
        try {
          await handleEcomanager(productsToSend[i]);
          successCount++;
        } catch (error) {
          failCount++;
          const errorMessage = getEcomanagerErrorMessage(error);
          if (errorMessage) {
            failMessages.push(errorMessage);
          }
        }

        // Mettre à jour la progression
        const progress = Math.round(((i + 1) / total) * 100);
        const progressBar = document.getElementById("eco-progress-bar");
        const progressText = document.getElementById("eco-progress-text");
        if (progressBar) progressBar.style.width = `${progress}%`;
        if (progressText) progressText.textContent = `${i + 1} / ${total}`;
        Swal.update({
          title: t("Products.Table.ecomanager.progressTitle", {
            current: i + 1,
            total,
          }),
        });
      }

      await Swal.fire({
        icon: failCount > 0 ? "warning" : "success",
        title:
          failCount > 0
            ? t("Products.Table.ecomanager.partialSuccess")
            : t("Products.Table.ecomanager.fullSuccess"),
        text:
          failCount > 0
            ? t("Products.Table.ecomanager.partialSuccessText", {
                success: successCount,
                fail: failCount,
              })
            : t("Products.Table.ecomanager.fullSuccessText", {
                success: successCount,
              }),
        footer:
          failCount > 0 && failMessages.length > 0
            ? failMessages[0]
            : undefined,
        confirmButtonColor: "#7e5395",
      });
    } finally {
      setIsSendingAllToEcomanager(false);
    }
  };

  const getProductSendKey = (product) => product?.id || product?.sku;

  const handleSendProductToEcomanager = async (product) => {
    const productKey = getProductSendKey(product);
    if (!productKey) return;

    if (product?.ecommanageractive) {
      Swal.fire({
        icon: "info",
        title: t("Products.Table.ecomanager.alreadySentTitle"),
        text: t("Products.Table.ecomanager.alreadySentText", {
          name: product?.name || t("Products.Table.headers.product"),
        }),
        confirmButtonColor: "#9b59bf",
      });
      return;
    }

    setSendingProductIds((prev) => {
      const next = new Set(prev);
      next.add(productKey);
      return next;
    });

    try {
      await handleEcomanager(product);
      await Swal.fire({
        icon: "success",
        title: t("Products.Table.ecomanager.productSent"),
        text: t("Products.Table.ecomanager.productSentText"),
        timer: 1800,
        timerProgressBar: true,
        showConfirmButton: false,
        position: "bottom-end",
        toast: true,
      });
    } catch (error) {
      const errorMessage = getEcomanagerErrorMessage(error);
      await Swal.fire({
        icon: "error",
        title: t("Products.Table.ecomanager.productFailed"),
        text: errorMessage || t("Products.Table.ecomanager.productFailedText"),
        confirmButtonColor: "#7e5395",
      });
    } finally {
      setSendingProductIds((prev) => {
        const next = new Set(prev);
        next.delete(productKey);
        return next;
      });
    }
  };

  const handleVerifyCode = async () => {
    if (verificationCode.length === 6) {
      try {
        const res = await fetch(
          "https://backend-digital.foorweb.store/api/verifyOtpGoogle",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              code: verificationCode,
              user: account?.user,
            }),
          },
        );

        const data = await res.json();

        if (data.success) {
          const chars =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
          let token = "";
          const length = 32;
          for (let i = 0; i < length; i++) {
            token += chars.charAt(Math.floor(Math.random() * chars.length));
          }

          // حفظ الـ token في localStorage
          localStorage.setItem("otpToken", token);

          // حفظ الـ token والوقت الحالي في Firestore
          const secretRef = doc(db, "secretKeys", account?.user);
          await updateDoc(secretRef, {
            token: token,
            lastUsed: Date.now(), // حفظ الوقت الحالي بالمللي ثانية
          });

          setShowOtpModal(false);
          setVerificationCode("");

          if (pendingRowData) {
            handleUpdate(pendingRowData);
            setPendingRowData(null);
          }
        } else {
          Swal.fire({
            icon: "error",
            title: t("ui.wrongCode"),
            confirmButtonText: t("ship.ok"),
            confirmButtonColor: "#7e5395",
            timer: 3000,
            timerProgressBar: true,
            position: "bottom-end",
            toast: true,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error("Error verifying code:", error);
      }
    }
  };

  const paidBodyTemplate = (rowData) => {
    const color = rowData.show === "1" ? "#12b669" : "#474747";

    return (
      <>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>{t("insightads.published")} </Tooltip>}
        >
          <div className="relative inline-block w-11 h-5">
            <input
              aria-label={t("insightads.status")}
              id={`switch-${rowData.id}`}
              type="checkbox"
              checked={rowData.show === "1"}
              onChange={
                !!account.store
                  ? (e) => {
                      changepaid(rowData, e.target.checked ? "1" : "0");
                    }
                  : () => {
                      message();
                    }
              }
              className="peer appearance-none w-11 h-5 bg-[#232323] border border-slate-300 rounded-full checked:bg-[#12b669] checked:border-slate-800 cursor-pointer transition-colors duration-300"
            />
            <label
              htmlFor={`switch-${rowData.id}`}
              className="absolute top-0 left-0 w-5 h-5 bg-white rounded-full border border-slate-300 shadow transition-transform duration-300 peer-checked:translate-x-6 peer-checked:border-slate-800 cursor-pointer"
            ></label>
          </div>
        </OverlayTrigger>
      </>
    );
  };

  const isOtpExpired = async () => {
    const tokenOtp = localStorage.getItem("otpToken");
    if (!tokenOtp) return true;

    try {
      // الحصول على بيانات المفتاح السري من Firestore
      const secretRef = doc(db, "secretKeys", account?.user);
      const secretDoc = await getDoc(secretRef);

      if (!secretDoc.exists()) {
        return true; // إذا لم يكن هناك مستند، فالـ OTP منتهي الصلاحية
      }

      const secretData = secretDoc.data();
      const storedToken = secretData.token;
      const lastUsed = secretData.lastUsed;

      // التحقق من أن الـ token متطابق
      if (storedToken !== tokenOtp) {
        return true;
      }

      // التحقق من أن الـ token لم يتجاوز 30 دقيقة (30 * 60 * 1000 = 1800000 مللي ثانية)
      const currentTime = Date.now();
      const timeDifference = currentTime - lastUsed;
      const thirtyMinutesInMs = 30 * 60 * 1000;

      if (timeDifference > thirtyMinutesInMs) {
        // إزالة الـ token من localStorage لأنه منتهي الصلاحية
        localStorage.removeItem("otpToken");
        return true;
      }

      return false; // الـ token صالح
    } catch (error) {
      console.error("Error checking OTP expiration:", error);
      return true; // في حالة الخطأ، نعتبر الـ token منتهي الصلاحية
    }
  };

  const CombinedTemplate = ({ rowData, confirmers, ...props }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState(new Set());
    const buttonImage = "/logo-min 2.png";
    const togglePopup = () => {
      setIsOpen(!isOpen);
    };

    const closePopup = () => {
      setIsOpen(false);
    };

    const toggleProductStatus = async (checked) => {
      const newStatus = checked;
      setIsAll(newStatus);
      const nextProduct = {
        ...rowData,
        isAll: newStatus,
      };
      await setDoc(doc(db, "products", rowData.id), nextProduct);
      dispatch(updateProduct(nextProduct));
    };

    const setUptoDelivery = async (checked) => {
      const newStatus1 = checked;
      setIsAll(newStatus1);
      const nextProduct = {
        ...rowData,
        upToDelivery: newStatus1,
      };
      await setDoc(doc(db, "products", rowData.id), nextProduct);
      dispatch(updateProduct(nextProduct));
    };

    const setEditOrders = async (checked) => {
      const newStatus2 = checked;
      setIsAll(newStatus2);
      const nextProduct = {
        ...rowData,
        editToOrders: newStatus2,
      };
      await setDoc(doc(db, "products", rowData.id), nextProduct);
      dispatch(updateProduct(nextProduct));
    };

    const handleAddProduct = async () => {
      if (selectedUsers.size === 0) {
        Swal.fire({
          title: t("error"),
          text: t("Products.Table.confirmers.selectUserError"),
          icon: "error",
          confirmButtonText: t("common.ok"),
        });
        return;
      }

      try {
        const newProductData = {
          active: true,
          beginDate: new Date(),
          endDate: null,
          shopName: account.name,
          shopUser: account.user,
          sku: [`${rowData.sku}`],
          storeImage: account.image,
        };
        //* do Api for rules
        const q = query(
          collection(db, "confirmers"),
          where("user", "in", Array.from(selectedUsers)),
        );

        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          Swal.fire({
            title: t("warning"),
            text: t("ui.userNotFound"),
            icon: "warning",
            confirmButtonText: t("common.ok"),
          });
          return;
        }

        const updates = querySnapshot.docs.map(async (doc) => {
          const data = doc.data();
          const existingProductIndex = data.products.findIndex(
            (product) => product.shopUser === account.user,
          );

          if (existingProductIndex !== -1) {
            const existingProduct = data.products[existingProductIndex];
            const skuIndex = existingProduct.sku.indexOf(rowData.sku);

            if (skuIndex !== -1) {
              // Remove the SKU if it exists
              existingProduct.sku.splice(skuIndex, 1);
              await updateDoc(doc.ref, { products: data.products });
            } else {
              // If 'all' is found, replace it with the new SKU
              const allIndex = existingProduct.sku.indexOf("all");
              if (allIndex !== -1) {
                existingProduct.sku[allIndex] = rowData.sku;
              } else {
                existingProduct.sku.push(rowData.sku);
              }
              await updateDoc(doc.ref, { products: data.products });
            }
          } else {
            // Add the new product
            await updateDoc(doc.ref, {
              products: arrayUnion(newProductData),
            });
          }
        });

        await Promise.all(updates);

        const result = await Swal.fire({
          title: t("Products.Table.confirmers.success"),
          icon: "success",
          confirmButtonText: t("common.ok"),
        });

        if (result.isConfirmed) {
          console.log("تم اختيار التاريخ:", result.value);
        }

        if (result.isConfirmed) {
          closePopup();
        }
      } catch (error) {
        console.error("Error adding/removing product: ", error);
        Swal.fire({
          title: t("error"),
          text:
            error.message || t("ui.productAssignmentError"),
          icon: "error",
          confirmButtonText: t("common.ok"),
        });
      }
    };

    const handleDelete = async (userId) => {
      // تأكيد المستخدم قبل الحذف
      const result = await Swal.fire({
        title: t("ship.confirm_delete"),
        text: t("ui.deleteProductConfirm"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("cashBack.swal.deleteConfirm.confirm"),
        cancelButtonText: t("annule"),
      });

      if (!result.isConfirmed) {
        // إذا لم يؤكد المستخدم، لا تنفذ عملية الحذف
        return;
      }

      try {
        const q = query(
          collection(db, "confirmers"),
          where("addedBy", "==", account.user),
        );

        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          Swal.fire({
            title: t("warning"),
            text: t("ui.userNotFound"),
            icon: "warning",
            confirmButtonText: t("common.ok"),
          });
          return;
        }

        const updates = querySnapshot.docs.map(async (doc) => {
          const data = doc.data();
          const productIndex = data.products.findIndex(
            (product) => product.shopUser === account.user,
          );

          if (productIndex !== -1) {
            let updatedProducts = [...data.products];
            const product = updatedProducts[productIndex];
            const skuIndex = product.sku.indexOf(rowData.sku);

            if (skuIndex !== -1) {
              product.sku.splice(skuIndex, 1);

              if (product.sku.length === 0) {
                // Replace with 'all' if SKU list is empty
                product.sku.push("all");
              }
            }

            // Update the product in Firestore
            await updateDoc(doc.ref, { products: updatedProducts });
          }
        });

        await Promise.all(updates);

        Swal.fire({
          title: t("Products.Table.confirmers.success"),
          text: t("ui.productRemoved"),
          icon: "success",
          confirmButtonText: t("common.ok"),
        });
      } catch (error) {
        console.error("Error deleting product: ", error);
        Swal.fire({
          title: t("error"),
          text: error.message || t("ui.deleteProductError"),
          icon: "error",
          confirmButtonText: t("common.ok"),
        });
      }
    };

    const handleCheckboxChange = (user, isChecked) => {
      const updatedSelectedUsers = new Set(selectedUsers);
      if (isChecked) {
        updatedSelectedUsers.add(user);
      } else {
        updatedSelectedUsers.delete(user);
      }
      setSelectedUsers(updatedSelectedUsers);
    };

    // حالة كل مفتاح تبديل
    const [systemNotification, setSystemNotification] = useState(true);
    const [salesAndNews, setSalesAndNews] = useState(false);
    const [accountTips, setAccountTips] = useState(true);

    return (
      <div className="relative">
        <button
          className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-[#faf1ff] dark:!border-[#3c3a3d] dark:!bg-[#181919] transition-colors active:bg-[#faf1ff] bot mx-auto"
          onClick={togglePopup}
        >
          <img src={buttonImage} style={{ width: "20px" }} alt={t("ui.buttonIcon")} />
        </button>

        <Modal
          visible={isOpen}
          onCancel={closePopup}
          footer={null}
          width="25%"
          destroyOnClose
          wrapClassName={isDark ? "dark-modal" : ""}
        >
          <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-[#3c3a3d] dark:bg-[#181919]">
            <h2 className="text-lg font-medium text-gray-800 dark:text-gray-200">
              {t("ui.productConfirmers")}
            </h2>
          </div>

          <div className="dark:bg-[#181919]">
            <div className="max-w-5xl mx-auto px-4 mt-2 md:px-8 dark:bg-[#181919]">
              <div className="flex justify-between p-4 rounded-md bg-blue-50 border border-blue-300 dark:!bg-[#1e1e1e] dark:border-[#3c3a3d]">
                <div className="flex gap-3">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-blue-500 dark:text-blue-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div className="self-center">
                    <span className="text-blue-600 dark:text-blue-400 font-medium">
                      {t("ui.noticeLabel")}
                    </span>
                    <div className="text-blue-600 dark:text-blue-400">
                      <p className="mt-2 sm:text-sm">
                        {t("ui.confirmerCapacityHelp")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ul className="grid gap-y-2 gap-x-6 flex-wrap mt-3 overflow-y-auto">
              {confirmers.map((confirmer, idx) => {
                const isSkuInConfirmer = confirmer.products?.some(
                  (product) =>
                    Array.isArray(product.sku) &&
                    product.sku.some((sku) => sku === rowData.sku),
                );
                const isChecked = isSkuInConfirmer;

                return (
                  confirmer.deleted !== true &&
                  isChecked && (
                    <div
                      className="ant-col ant-col-24 hp-border-radius-lx hp-border-1 border border-gray-200 dark:border-[#3c3a3d] dark:bg-[#1e1e1e]"
                      style={{
                        paddingLeft: "6px",
                        paddingRight: "6px",
                        position: "relative",
                      }}
                      key={idx}
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/9427/9427108.png"
                        style={{ zIndex: 10, width: "22px" }}
                        onClick={() => handleDelete(confirmer.user)}
                        className="absolute top-0 left-0 cursor-pointer"
                      />

                      <div
                        className="ant-row ant-row-space-between ant-row-middle"
                        style={{ rowGap: "0px" }}
                      >
                        <div className="ant-col ant-col-24 hp-mb-sm-16 ant-col-sm-12">
                          <div
                            className="ant-row ant-row-no-wrap ant-row-middle"
                            style={{ rowGap: "0px" }}
                          >
                            <Checkbox
                              id={`confirmer-${idx}`}
                              type="checkbox"
                              className="checkbox-item peer hidden"
                              onChange={(e) =>
                                handleCheckboxChange(
                                  confirmer.user,
                                  e.target.checked,
                                )
                              }
                              checked
                              disabled
                            />

                            <div className="ant-col">
                              <div
                                className="hp-border-radius-md hp-cursor-pointer hp-border-1 hp-mr-16 m-2 rounded-full border-gray-300 dark:border-[#3c3a3d]"
                                style={{
                                  maxHeight: "64px",
                                  maxWidth: "64px",
                                }}
                              >
                                <div className="hp-border-radius-in hp-overflow-hidden hp-m-4 hp-d-flex rounded-full">
                                  <img
                                    src={
                                      confirmer.image ||
                                      "https://randomuser.me/api/portraits/women/79.jpg"
                                    }
                                    alt={t("workersManagement.table.user")}
                                    style={{ height: "100%" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="ant-col">
                              <span className="hp-d-block hp-p3-body hp-font-weight-700 text-gray-800 dark:text-gray-200">
                                {confirmer.name}
                              </span>
                              <span
                                className="hp-d-block hp-p1-body text-gray-700 dark:text-gray-400"
                                style={{ fontSize: "11px" }}
                              >
                                {confirmer.phone}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          className="ant-col ant-col-12 hp-text-sm-left hp-text-right ant-col-sm-6"
                          style={{ minHeight: "50px" }}
                        >
                          <span className="hp-d-block hp-p3-body hp-font-weight-400 hp-slashed-zero text-gray-800 dark:text-gray-200">
                            {t("ui.confirmedLabel")}{" "}
                            <span className="fs-2-5 ">
                              {" "}
                              {confirmer.pricing?.confirmPrice}{" "}
                              {localizedCurrency}
                            </span>
                          </span>
                          <span className="hp-d-block hp-p1-body hp-mt-4 hp-slashed-zero text-gray-700 dark:text-gray-400">
                            {t("ui.cancelledLabel")}{" "}
                            <span className="fs-2-4 ">
                              {" "}
                              {confirmer.pricing?.cancelPrice}{" "}
                              {localizedCurrency}
                            </span>
                          </span>
                        </div>
                        <div className="ant-col">
                          <a href={`tel:${confirmer.phone}`}>
                            <img
                              src="https://cdn-icons-png.flaticon.com/128/16620/16620482.png"
                              alt={t("workersManagement.table.user")}
                              style={{
                                maxWidth: "34px",
                                cursor: "pointer",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  )
                );
              })}
            </ul>

            <ul className="grid gap-y-2 gap-x-6 flex-wrap mt-3">
              {confirmers.map((confirmer, idx) => {
                const isSkuInConfirmer = confirmer.products?.some(
                  (product) =>
                    Array.isArray(product.sku) &&
                    product.sku.some((sku) => sku === rowData.sku),
                );
                const isChecked = isSkuInConfirmer;

                return (
                  confirmer.deleted !== true &&
                  !isChecked && (
                    <div
                      className="ant-col ant-col-24 hp-border-radius-lx hp-border-1 border border-gray-200 dark:border-[#3c3a3d] dark:bg-[#1e1e1e]"
                      style={{ paddingLeft: "6px", paddingRight: "6px" }}
                      key={idx}
                    >
                      <div
                        className="ant-row ant-row-space-between ant-row-middle"
                        style={{ rowGap: "0px" }}
                      >
                        <div className="ant-col ant-col-24 hp-mb-sm-16 ant-col-sm-12">
                          <div
                            className="ant-row ant-row-no-wrap ant-row-middle"
                            style={{ rowGap: "0px" }}
                          >
                            <Checkbox
                              id={`confirmer-${idx}`}
                              type="checkbox"
                              className="checkbox-item peer hidden"
                              onChange={(e) =>
                                handleCheckboxChange(
                                  confirmer.user,
                                  e.target.checked,
                                )
                              }
                            />

                            <div className="ant-col">
                              <div
                                className="hp-border-radius-md hp-cursor-pointer hp-border-1 hp-mr-16 m-2 rounded-full border-gray-300 dark:border-[#3c3a3d]"
                                style={{
                                  maxHeight: "64px",
                                  maxWidth: "64px",
                                }}
                              >
                                <div className="hp-border-radius-in hp-overflow-hidden hp-m-4 hp-d-flex rounded-full">
                                  <img
                                    src={
                                      confirmer.image ||
                                      "https://randomuser.me/api/portraits/women/79.jpg"
                                    }
                                    alt={t("workersManagement.table.user")}
                                    style={{ height: "100%" }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="ant-col">
                              <span className="hp-d-block hp-p3-body hp-font-weight-700 text-gray-800 dark:text-gray-200">
                                {confirmer.name}
                              </span>
                              <span
                                className="hp-d-block hp-p1-body text-gray-700 dark:text-gray-400"
                                style={{ fontSize: "11px" }}
                              >
                                {confirmer.phone}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          className="ant-col ant-col-12 hp-text-sm-left hp-text-right ant-col-sm-6"
                          style={{ minHeight: "50px" }}
                        >
                          <span className="hp-d-block hp-p3-body hp-font-weight-400 hp-slashed-zero text-gray-800 dark:text-gray-200">
                            {t("ui.confirmedLabel")}{" "}
                            <span className="fs-2-5">
                              {confirmer.pricing?.confirmPrice}{" "}
                              {localizedCurrency}
                            </span>
                          </span>
                          <span className="hp-d-block hp-p1-body hp-mt-4 hp-slashed-zero text-gray-700 dark:text-gray-400">
                            {t("ui.cancelledLabel")}{" "}
                            <span className="fs-2-4">
                              {confirmer.pricing?.cancelPrice}{" "}
                              {localizedCurrency}
                            </span>
                          </span>
                        </div>
                        <div className="ant-col">
                          <a href={`tel:${confirmer.phone}`}>
                            <img
                              src="https://cdn-icons-png.flaticon.com/128/16620/16620482.png"
                              alt={t("workersManagement.table.user")}
                              style={{
                                maxWidth: "34px",
                                cursor: "pointer",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  )
                );
              })}
            </ul>
            <div className="p-4 border-t border-gray-200 dark:border-[#3c3a3d] mt-4 dark:bg-[#181919]">
              <div className="ant-col ant-col-24">
                <h3 className="text-gray-800 dark:text-gray-200">{t("servicePageActivation.foorchat.settingchat.title")}</h3>
                <div className="hp-profile-notifications hp-mt-24">
                  {/* Switch 1 */}
                  <Row
                    className="ant-row-space-between ant-row-middle"
                    style={{ rowGap: 0 }}
                  >
                    <Col
                      className="hp-caption text-gray-800 dark:text-gray-300"
                      span={24}
                      xs={15}
                    >
                      {t("ui.showToConfirmers")}
                    </Col>
                    <Col>
                      <Switch
                        style={{ width: "45px" }}
                        checked={rowData.isAll}
                        onChange={(checked) => {
                          Swal.fire({
                            title: t("cashBack.swal.deleteConfirm.title"),
                            text: t("Products.Table.confirmers.changeStatusText"),
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: t("ui.yesChange"),
                          }).then((result) => {
                            if (result.isConfirmed) {
                              toggleProductStatus(checked);
                            }
                          });
                        }}
                        checkedChildren=""
                        unCheckedChildren=""
                        className="hp-mt-sm-8 hp-ml-sm-0 hp-ml-8"
                      />
                    </Col>
                  </Row>

                  {/* Switch 2 */}
                  <Row
                    className="ant-row-space-between ant-row-middle hp-mt-18"
                    style={{ rowGap: 0 }}
                  >
                    <Col
                      className="hp-caption text-gray-800 dark:text-gray-300"
                      span={24}
                      xs={15}
                    >
                      {t("ui.confirmerEditHelp")}
                    </Col>
                    <Col>
                      <Switch
                        style={{ width: "45px" }}
                        checked={rowData.editToOrders}
                        onChange={(checked) => {
                          Swal.fire({
                            title: t("cashBack.swal.deleteConfirm.title"),
                            text: t("Products.Table.confirmers.changeStatusText"),
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: t("ui.yesChange"),
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setEditOrders(checked);
                            }
                          });
                        }}
                        checkedChildren=""
                        unCheckedChildren=""
                        className="hp-mt-sm-8 hp-ml-sm-0 hp-ml-8"
                      />
                    </Col>
                  </Row>

                  {/* Switch 3 */}
                  <Row
                    className="ant-row-space-between ant-row-middle hp-mt-18"
                    style={{ rowGap: 0 }}
                  >
                    <Col
                      className="hp-caption text-gray-800 dark:text-gray-300"
                      span={24}
                      xs={15}
                    >
                      {t("ui.autoSendHelp")}
                    </Col>
                    <Col>
                      <Switch
                        style={{ width: "45px" }}
                        checked={rowData.upToDelivery}
                        onChange={(checked) => {
                          Swal.fire({
                            title: t("cashBack.swal.deleteConfirm.title"),
                            text: t("Products.Table.confirmers.changeStatusText"),
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: t("ui.yesChange"),
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setUptoDelivery(checked);
                            }
                          });
                        }}
                        checkedChildren=""
                        unCheckedChildren=""
                        className="hp-mt-sm-8 hp-ml-sm-0 hp-ml-8"
                      />
                    </Col>
                  </Row>
                </div>
              </div>

              {/* Bouton Confirmer */}
              <div className="p-4 border-t border-gray-200 dark:border-[#3c3a3d] mt-4">
                <button
                  className="w-full px-4 py-2 text-white bg-[#9b59bf] hover:bg-[#8a4eaa] rounded-md focus:outline-none focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
                  onClick={handleAddProduct}
                >
                  {t("ui.confirmAction")}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  };

  const ProductButton = (product) => {
    const productKey = getProductSendKey(product);
    const isSending = sendingProductIds.has(productKey);
    const isAlreadySent = !!product?.ecommanageractive;

    return (
      <div className="relative inline-flex">
        <button
          onClick={() => handleSendProductToEcomanager(product)}
          disabled={isSending}
          className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-[#faf1ff] dark:!bg-[#181919] dark:!border-[#3c3a3d] transition-colors active:bg-[#faf1ff] disabled:opacity-60 disabled:cursor-not-allowed bot mx-auto"
        >
          {isSending ? (
            <svg
              className="animate-spin h-5 w-5 text-[#9e68ba]"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          ) : (
            <img
              src="/ecomanger.png"
              style={{ width: "20px" }}
              alt={t("ui.buttonIcon")}
            />
          )}
        </button>
        {product?.ecommanageractive && (
          <span
            className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 border-2 border-white dark:border-[#181919] rounded-full"
            title={t("Products.Table.ecomanager.alreadyUploaded")}
          />
        )}
      </div>
    );
  };

  // دالة لاستخراج src من نص HTML
  const extractImageSrc = (htmlString) => {
    if (!htmlString) return null;
    const match = htmlString.match(/<img[^>]+src=["']([^"']+)["']/i);
    return match ? match[1] : null;
  };

  const imageBodyTemplate = (rowData) => {
    const isAiGenerated = rowData.created_via === "FoorAiLandingPageGenerator";

    return (
      <div className="relative w-16 h-16">
        {rowData.image ? (
          <div className="absolute w-14 h-14 rounded-lg overflow-hidden bg-[#faf1ff] shadow-sm">
            <img
              src={rowData.image}
              onError={(e) => (e.target.src = "/product-foorweb.png")}
              alt={rowData.name || t("settings.product")}
              className="w-full h-full object-cover"
            />
          </div>
        ) : (
          <div className="absolute w-14 h-14 rounded-lg overflow-hidden bg-[#faf1ff] shadow-sm flex items-center justify-center text-[#9e68ba]">
            <Tag size={24} />
          </div>
        )}

        {isAiGenerated && (
          <div
            className="absolute -top-1 -right-1 bg-gradient-to-r from-[#9b59bf] to-[#7e5395] text-white rounded-full px-1.5 py-0.5 flex items-center justify-center shadow-md"
            style={{ fontSize: "9px", lineHeight: "1" }}
            title={t("ui.aiGenerated")}
          >
            <Sparkle size={9} className="ml-0.5" />
            <span>AI</span>
          </div>
        )}
      </div>
    );
  };

  const priceproduct = (rowData) => {
    return (
      <div className="flex items-center justify-start gap-2 text-gray-700">
        <span className="text-end font-medium" style={{ color: "#6e4881" }}>
          {rowData.price} {localizedCurrency}
        </span>
      </div>
    );
  };

  const visitspriproduct = (rowData) => {
    return (
      <div className="flex items-center justify-start gap-2 text-gray-700">
        <span className="text-end">{rowData.visits ? rowData.visits : 0}</span>
      </div>
    );
  };

  const openLandingPage = (rowData) => {
    if (!account?.store) return message();
    const baseUrl = account.store.replace(/\/+$/, "");

    const finalUrl = `${baseUrl}/Landingpage/${rowData.url}`;

    window.open(finalUrl, "_blank", "noopener,noreferrer");
  };

  const openProductPage = (rowData) => {
    if (!account?.store) return message();
    let finalUrl = "";

    if (account.productMode === "digital") {
      const storeName = account?.store?.split(".")[0];
      const newDomain = `${storeName}.foorweb.online`;
      finalUrl = `${newDomain}/products/${rowData.url}`;
    } else {
      const baseUrl = account.store.replace(/\/+$/, "");
      const storeName = baseUrl.split("://")[1].split(".")[0];

      finalUrl = `${baseUrl}/${storeName}/products/${rowData.url}`;
    }

    window.open(finalUrl, "_blank", "noopener,noreferrer");
  };

  const editProduct = async (rowData) => {
    if (!account.store) return message();
    if (account?.productMode != "digital" || !account?.twoFAActivated)
      return handleUpdate(rowData);
    const expired = await isOtpExpired();
    if (expired) {
      setPendingRowData(rowData);
      setShowOtpModal(true);
    } else {
      handleUpdate(rowData);
    }
  };

  const removeProduct = (rowData) => {
    if (!account.store) return message();
    handleDelete(rowData);
  };

  const formatNumber = (value) =>
    new Intl.NumberFormat(currentLang === "ar" ? "ar-DZ" : currentLang).format(
      Number(value) || 0,
    );

  const LandingPageCard = ({ product }) => {
    const published = product.show === "1";
    const qty = Number(product.qty) || 0;
    const hasDiscount =
      Number(product.comparePrice) > Number(product.price) ||
      Number(product.oldPrice) > Number(product.price);
    const oldPrice = product.comparePrice || product.oldPrice;

    return (
      <article className="group relative flex flex-col bg-white dark:!bg-[#1c1c1d] rounded-2xl border border-[#f0e6f6] dark:!border-[#333135] shadow-[0_1px_2px_rgba(126,83,149,0.06)] hover:shadow-[0_18px_40px_-18px_rgba(126,83,149,0.45)] hover:-translate-y-1 transition-all duration-300 overflow-hidden">
        {/* Cover */}
        <div className="relative aspect-[4/3] overflow-hidden bg-gradient-to-br from-[#faf1ff] to-[#efe0f7] dark:from-[#241f27] dark:to-[#2d2333]">
          {product.image ? (
            <img
              src={product.image}
              onError={(e) => (e.target.src = "/product-foorweb.png")}
              alt={product.name || ""}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-[#c9a6dc]">
              <Tag size={44} />
            </div>
          )}

          <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/0 to-black/10 opacity-70 group-hover:opacity-100 transition-opacity" />

          <span className="absolute top-2 start-2 sm:top-3 sm:start-3 inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-[#9b59bf] to-[#7e5395] text-white text-[10px] sm:text-[11px] font-semibold px-2 sm:px-2.5 py-0.5 sm:py-1 shadow-md">
            <Sparkle size={11} />
            {t("foorAi.projectCenter.projectCard.badges.ai")}
          </span>

          <span
            className={`absolute top-2 end-2 sm:top-3 sm:end-3 inline-flex items-center gap-1 sm:gap-1.5 rounded-full backdrop-blur-md text-[10px] sm:text-[11px] font-semibold px-2 sm:px-2.5 py-0.5 sm:py-1 ${
              published
                ? "bg-emerald-500/90 text-white"
                : "bg-white/85 text-gray-700 dark:bg-black/60 dark:text-gray-200"
            }`}
          >
            <span
              className={`w-1.5 h-1.5 rounded-full ${
                published ? "bg-white" : "bg-gray-400"
              }`}
            />
            {published
              ? t("Products.Table.card.published", { defaultValue: "منشور" })
              : t("Products.Table.card.hidden", { defaultValue: "غير منشور" })}
          </span>

          <button
            type="button"
            onClick={() => openLandingPage(product)}
            className="hidden sm:inline-flex absolute bottom-3 inset-x-3 items-center justify-center gap-2 rounded-xl bg-white/95 dark:bg-[#1c1c1d]/95 text-[#7e5395] dark:text-[#d2a8ec] text-sm font-semibold py-2.5 shadow-lg opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 focus:opacity-100 focus:translate-y-0 transition-all duration-300"
          >
            <ExternalLink size={15} />
            {t("Products.Table.card.previewLanding", {
              defaultValue: "معاينة صفحة الهبوط",
            })}
          </button>
        </div>

        {/* Body */}
        <div className="flex flex-col flex-1 p-2.5 sm:p-4 gap-2 sm:gap-3">
          <div className="min-w-0">
            <h3
              className="text-[13px] sm:text-[15px] font-bold text-gray-900 dark:text-gray-100 leading-snug line-clamp-2 min-h-[2.6em] m-0"
              title={product.name}
            >
              {product.name}
            </h3>
            {product.sku && (
              <span className="mt-1.5 inline-block max-w-full truncate rounded-md bg-gray-100 dark:bg-[#2a2a2c] text-gray-500 dark:text-gray-400 text-[11px] font-mono px-1.5 py-0.5">
                {product.sku}
              </span>
            )}
          </div>

          <div className="flex items-baseline gap-2">
            <span className="text-base sm:text-xl font-extrabold tabular-nums text-[#7e5395] dark:text-[#d2a8ec]">
              {formatNumber(product.price)}
            </span>
            <span className="text-xs font-semibold text-[#9e68ba]">
              {localizedCurrency}
            </span>
            {hasDiscount && (
              <span className="text-xs text-gray-400 line-through tabular-nums">
                {formatNumber(oldPrice)}
              </span>
            )}
          </div>

          <div className="grid grid-cols-2 gap-1.5 sm:gap-2">
            <div className="flex items-center gap-2 rounded-lg sm:rounded-xl bg-[#faf5fd] dark:bg-[#242226] px-2 sm:px-3 py-1.5 sm:py-2">
              <BarChart3
                size={15}
                className="hidden sm:block text-[#9e68ba] shrink-0"
              />
              <div className="min-w-0 leading-tight">
                <div className="text-[11px] text-gray-500 dark:text-gray-400 truncate">
                  {t("Products.Table.headers.visits")}
                </div>
                <div className="text-sm font-bold tabular-nums text-gray-800 dark:text-gray-100">
                  {formatNumber(product.visits)}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2 rounded-lg sm:rounded-xl bg-[#faf5fd] dark:bg-[#242226] px-2 sm:px-3 py-1.5 sm:py-2">
              <Package
                size={15}
                className={`hidden sm:block shrink-0 ${
                  qty <= 0 ? "text-rose-500" : "text-[#9e68ba]"
                }`}
              />
              <div className="min-w-0 leading-tight">
                <div className="text-[11px] text-gray-500 dark:text-gray-400 truncate">
                  {t("Products.Table.headers.quantity")}
                </div>
                <div
                  className={`text-sm font-bold tabular-nums ${
                    qty <= 0
                      ? "text-rose-500"
                      : "text-gray-800 dark:text-gray-100"
                  }`}
                >
                  {formatNumber(qty)}
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-auto pt-2.5 sm:pt-3 border-t border-[#f4ecf8] dark:border-[#333135] flex flex-col gap-2 sm:gap-2.5">
            <div className="flex items-center justify-between gap-1">
              <div className="flex items-center gap-2">
                {paidBodyTemplate(product)}
              </div>

              <div className="flex items-center sm:gap-1">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>{t("Products.Table.Actions.edit")}</Tooltip>
                  }
                >
                  <button
                    type="button"
                    onClick={() => editProduct(product)}
                    className="h-8 w-8 sm:h-9 sm:w-9 rounded-lg flex items-center justify-center text-gray-600 dark:text-gray-300 hover:bg-[#f5ebfb] hover:text-[#7e5395] dark:hover:bg-[#2a2a2c] transition-colors"
                  >
                    <Edit size={16} />
                  </button>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      {t("Products.Table.Actions.viewProduct", {
                        defaultValue: "صفحة المنتج",
                      })}
                    </Tooltip>
                  }
                >
                  <button
                    type="button"
                    onClick={() => openProductPage(product)}
                    className="h-8 w-8 sm:h-9 sm:w-9 rounded-lg flex items-center justify-center text-gray-600 dark:text-gray-300 hover:bg-[#f5ebfb] hover:text-[#7e5395] dark:hover:bg-[#2a2a2c] transition-colors"
                  >
                    <Eye size={16} />
                  </button>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>{t("Products.Table.Actions.delete")}</Tooltip>
                  }
                >
                  <button
                    type="button"
                    onClick={() => removeProduct(product)}
                    className="h-8 w-8 sm:h-9 sm:w-9 rounded-lg flex items-center justify-center text-gray-600 dark:text-gray-300 hover:bg-rose-50 hover:text-rose-600 dark:hover:bg-rose-950/40 transition-colors"
                  >
                    <Trash size={16} />
                  </button>
                </OverlayTrigger>
              </div>
            </div>
            <button
              type="button"
              onClick={() => openLandingPage(product)}
              className="w-full h-9 rounded-lg inline-flex items-center justify-center gap-1.5 bg-gradient-to-r from-[#9b59bf] to-[#7e5395] text-white text-xs sm:text-sm font-semibold shadow-sm hover:shadow-md hover:brightness-110 transition"
            >
              <ExternalLink size={14} />
              {t("Products.Table.headers.preview")}
            </button>
          </div>
        </div>
      </article>
    );
  };

  const visibleProducts = !!filter ? products : _DATA.currentData();

  return (
    <div className="w-full">
      <div className="p-3 sm:p-5">
        {products.length > 0 ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
            {visibleProducts.map((product, index) => (
              <LandingPageCard key={product.id || index} product={product} />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center text-center py-16 px-4 rounded-2xl border-2 border-dashed border-[#e9d8f3] dark:border-[#3c3a3d] bg-white/60 dark:bg-[#1a1a1b]">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#9b59bf] to-[#7e5395] text-white flex items-center justify-center shadow-lg mb-4">
              <LayoutTemplate size={30} />
            </div>
            <h3 className="text-lg font-bold text-gray-800 dark:text-gray-100 mb-1">
              {t("Products.Table.empty")}
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 max-w-sm m-0">
              {t("Products.Table.card.emptyHint", {
                defaultValue:
                  "أنشئ أول صفحة هبوط بالذكاء الاصطناعي وستظهر هنا.",
              })}
            </p>
          </div>
        )}
        {showOtpModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-md w-96 shadow-lg">
              <h2 className="text-lg font-semibold mb-4 text-center text-gray-700">
                {t("Products.Table.otp.title")}
              </h2>
              <input
                type="text"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                maxLength={6}
                className="w-full border border-gray-300 rounded-md px-4 py-2 mb-4 text-center text-lg tracking-widest"
                placeholder="______"
              />
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setShowOtpModal(false)}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
                >
                  {t("Products.Table.otp.cancel")}
                </button>
                <button
                  onClick={handleVerifyCode}
                  className="px-4 py-2 bg-[#7e5395] text-white rounded-md"
                >
                  {t("Products.Table.otp.verify")}
                </button>
              </div>
            </div>
          </div>
        )}

        {!filter && count > 1 && (
          <div className="flex justify-center mt-6">
            <Stack spacing={2} dir="ltr">
              <Pagination
                count={count}
                size="large"
                page={page}
                variant="outlined"
                shape="rounded"
                onChange={handleChange}
                color="secondary"
                sx={{
                  "& .MuiPaginationItem-root": {
                    color: isDark ? "#e1cfff" : "#4b3b55",
                    borderColor: isDark ? "#3c3a3d" : "#ead9f4",
                    backgroundColor: isDark ? "#1c1c1d" : "#ffffff",
                    borderRadius: "10px",
                    fontWeight: 600,
                  },
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: isDark ? "#9b59bf" : "#9b59bf",
                    color: "#fff",
                  },
                  "& .MuiPaginationItem-root:hover": {
                    backgroundColor: isDark ? "#7c3aad" : "#f0f0f0",
                  },
                }}
              />
            </Stack>
          </div>
        )}
      </div>
    </div>
  );
};

export default DataTableTemplatingDemo;
